webix.protoUI(
    {
        /** @type {string} Name of the custom UI component */
        name: 'tinymce-editor',

        /** @type {Object} Default configuration for the editor */
        defaults: {
            config: { theme: 'modern', statusbar: false }, // TinyMCE configuration
            barHeight: 72, // Height of the editor's toolbar
            value: '', // Initial content of the editor
        },

        /** @function $init Initializes the editor component */
        $init: function () {
            this.$view.className += ' webix_selectable'; // Makes the editor selectable

            this._waitEditor = webix.promise.defer(); // Promise to handle editor loading
            this.$ready.push(this.render); // Adds render function to the ready queue
        },

        /** @function render Renders the editor component */
        render: function () {
            this._set_inner_size(); // Sets the inner size of the editor
        },

        /** @function _require_tinymce_once Loads TinyMCE library if not already loaded */
        _require_tinymce_once: function () {
            this._mce_id = 'webix_mce_' + this.config.id; // Unique ID for the TinyMCE instance
            this.$view.innerHTML = "<textarea id='" + this._mce_id + "' style='width:1px; height:1px'></textarea>"; // Creates a textarea for TinyMCE

            if (this.config.cdn === false) {
                this._init_tinymce_once(); // Initializes TinyMCE directly if CDN is disabled
                return;
            }

            var cdn = this.config.cdn ? this.config.cdn : 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/4.7.13'; // CDN URL for TinyMCE

            /** @type {Object} Configuration for TinyMCE pre-initialization */
            window.tinyMCEPreInit = {
                query: '',
                base: cdn, // Base URL for TinyMCE
                suffix: '.min', // Suffix for minified files
            };

            webix
                .require([cdn + '/tinymce.min.js']) // Loads TinyMCE script
                .then(webix.bind(this._init_tinymce_once, this)) // Initializes TinyMCE once loaded
                .catch(function (e) {
                    console.log(e); // Logs any errors during loading
                });
        },

        /** @function _init_tinymce_once Initializes TinyMCE editor */
        _init_tinymce_once: function () {
            if (!tinymce.dom.Event.domLoaded) {
                tinymce.dom.Event.domLoaded = true; // Workaround for TinyMCE event logic
                webix.html.addStyle(
                    '.mce-tinymce.mce-container{ border-width:0px !important}', // Custom styles for TinyMCE
                );
            }

            var config = this.config.config; // Retrieves the TinyMCE configuration

            config.mode = 'exact'; // Sets mode to exact for specific element
            config.height = 300; // Sets the height of the editor
            config.elements = [this._mce_id]; // Specifies the element to initialize
            config.id = this._mce_id; // Sets the ID for the editor

            var customsetup = config.setup; // Stores any custom setup function
            config.setup = webix.bind(function (editor) {
                if (customsetup) customsetup(editor); // Calls custom setup if defined
                this._mce_editor_setup(editor); // Sets up the editor
            }, this);

            tinyMCE.init(config); // Initializes TinyMCE with the provided configuration

            this._init_tinymce_once = function () {}; // Prevents re-initialization
        },

        /** @function _mce_editor_setup Sets up event listeners for the TinyMCE editor */
        _mce_editor_setup: function (editor) {
            editor.on('init', webix.bind(this._mce_editor_ready, this)); // Binds the ready event
        },

        /** @function _mce_editor_ready Called when the TinyMCE editor is ready */
        _mce_editor_ready: function () {
            this._3rd_editor = tinyMCE.get(this._mce_id); // Retrieves the TinyMCE instance
            this._set_inner_size(); // Sets the inner size of the editor
            this._waitEditor.resolve(this._3rd_editor); // Resolves the promise with the editor instance

            this.setValue(this.config.value); // Sets the initial value of the editor
            if (this._focus_await) this.focus(); // Focuses the editor if awaiting focus
        },

        /** @function _set_inner_size Adjusts the inner size of the TinyMCE editor */
        _set_inner_size: function () {
            if (!this._3rd_editor || !this.$width) return; // Checks if editor is initialized and width is set
            this._3rd_editor.theme.resizeTo(
                this.$width - 2, // Resizes the editor width
                this.$height - this.config.barHeight, // Resizes the editor height
            );
        },

        /** @function $setSize Sets the size of the editor component */
        $setSize: function (x, y) {
            if (webix.ui.view.prototype.$setSize.call(this, x, y)) {
                if (!this._3rd_editor) this._require_tinymce_once(); // Loads TinyMCE if not initialized
                this._set_inner_size(); // Adjusts the inner size
            }
        },

        /** @function setValue Sets the content of the TinyMCE editor */
        setValue: function (value) {
            this.config.value = value; // Updates the stored value
            if (this._3rd_editor) this._3rd_editor.setContent(value); // Sets content in the editor
        },

        /** @function getValue Retrieves the content of the TinyMCE editor */
        getValue: function () {
            return this._3rd_editor
                ? this._3rd_editor.getContent() // Gets content from the editor if initialized
                : this.config.value; // Returns stored value if editor is not initialized
        },

        /** @function focus Focuses the TinyMCE editor */
        focus: function () {
            this._focus_await = true; // Marks that focus is awaited
            if (this._3rd_editor) this._3rd_editor.focus(); // Focuses the editor if initialized
        },

        /** @function getEditor Retrieves the TinyMCE editor instance */
        getEditor: function (waitEditor) {
            return waitEditor ? this._waitEditor : this._3rd_editor; // Returns the appropriate editor instance
        },
    },
    webix.ui.view,
);

// FILE DOCUMENTED
